import moment from 'moment';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { useQuery } from 'react-query';
import useMessageTemplates from '../../../../hooks/useMessageTemplates';
import {
  scrollToBottomOfChat,
  setMsgChatMessages,
  setMsgReminderId,
  setMsgClient,
  setMsgSearchText,
  setMsgResetClient,
  setShowSearchResults,
  setUserDraft,
} from '../../../../reducers/messaging';
import PopMessagePayment from './PopMessagePayment';
import sendAPIChatMessage from '../Helpers/API/sendChatMessage';
import ChatTemplatePopup from './ChatTemplatePopup';
import MessageInputActions from './MessageInputActions';
import WhatsappMessageInput from './WhatsappMessageInput/index';
import { useDragAndDrop } from '../../../../context/DragDropContext';
import { postRequest, putRequest } from '../../../../core/apiRequests';
import { clientbookApi } from '../../../../core/clientbook-api';
import ChatModal from './ChatModal';
import PopMessage from '../../PopMessage';
import { getReminderData } from './helpers';
import { getReviewUrl } from '../../../../utils/getBaseUrl';
import StoreModal from './StoreModal';
import { deleteUserDraft } from '../../../../services/userDraft';
import { nonInverseRelationshipTypes } from '../../../../utils/nonInverseRelationshipTypes';
import { getValidatedStoreIdFromProps } from '../../../../utils/storeAccess';
import { getFirstName } from '../../../../utils';

const ChatInputFooter = props => {
  const timeOffset = moment(new Date()).utcOffset();
  const [messageTxt, setMessageTxt] = useState('');
  const { fileData, fileDispatch } = useDragAndDrop();
  const [paymentRequestID, setPaymentRequestID] = useState('');
  const [templatePopup, showTemplatePopup] = useState(false);
  const [paymentsPopup, showPaymentsPopup] = useState(false);
  const [relationships, setRelationships] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedVendorItems, setSelectedVendorItems] = useState([]);
  const [selectedCollections, setSelectedCollections] = useState([]);
  const [showPopReminder, setShowPopReminder] = useState(false);
  const [showPopSuccessReminder, setShowPopSuccessReminder] = useState(false);
  const [showStoreModal, setShowStoreModal] = useState(false);
  const [isSendAndArchive, setIsSendAndArchive] = useState(false);

  useEffect(() => {
    setMessageTxt(''); // this should be called any time the client_id changes
  }, [props?.messaging?.client?.client_id]);

  const whatsappTimeCheck = (preferred_contact_type, WA_receive) => {
    if (
      preferred_contact_type === 'WHATSAPP' &&
      (WA_receive ? !(moment(new Date()).diff(moment(WA_receive), 'hours') < 24) : true)
    ) {
      return false;
    }
    return true;
  };

  const handleAddProduct = useCallback(
    product => {
      const productArray = [...selectedProducts];
      productArray.push(product);
      setSelectedProducts(productArray);
    },
    [selectedProducts],
  );

  const handleDeleteProduct = useCallback(
    id => {
      const productArray = selectedProducts.filter(product => product.id !== id);
      setSelectedProducts(productArray);
    },
    [selectedProducts],
  );

  const handleAddVendorItem = useCallback(
    product => {
      const productArray = [...selectedVendorItems];
      productArray.push(product);
      setSelectedVendorItems(productArray);
    },
    [selectedVendorItems],
  );
  const handleDeleteVendorItem = useCallback(
    id => {
      const productArray = selectedVendorItems.filter(product => product.id !== id);
      setSelectedVendorItems(productArray);
    },
    [selectedVendorItems],
  );

  const handleAddCollection = useCallback(
    collection => {
      const productArray = [...selectedCollections, ...collection];
      setSelectedCollections(productArray);
    },
    [selectedCollections],
  );

  const handleDeleteCollection = useCallback(
    id => {
      const collectionArray = selectedCollections.filter(item => item.collection_id !== id);
      setSelectedCollections(collectionArray);
    },
    [selectedCollections],
  );

  const sendStructuredMessage = ({
    type,
    clientId,
    chatId,
    storeId,
    message,
    productIds,
    vendorItems,
    collectionIds,
    isOpen,
  }) => {
    if (type === 'F' || type === 'I') {
      const platform = type === 'F' ? 'facebook' : 'instagram';
      return clientbookApi.post({
        url: `/meta/${platform}/chats/${chatId}/messages`,
        data: {
          ...(message && { message }),
          ...(productIds?.length > 0 && { productIds }),
          ...(isOpen !== undefined && { isOpen }),
        },
      });
    }
    return clientbookApi.post({
      url: `/chats/${clientId}`,
      data: {
        ...(message && { message }),
        ...(storeId && { storeId: String(storeId) }),
        ...(productIds?.length > 0 && { productIds }),
        ...(vendorItems?.length > 0 && { vendorItems }),
        ...(collectionIds?.length > 0 && { collectionIds }),
        ...(isOpen !== undefined && { isOpen }),
      },
    });
  };

  const insertIntoConversationList = (selectedArr, respData, chatId, selectionType) => {
    const tempChatList = props.messaging.chatMessages;
    let fakeChatObj = {};
    let fakeMessageObj = {};
    selectedArr.forEach(selection => {
      if (messageTxt) {
        fakeMessageObj = {
          clientId: props.messaging.client.client_id,
          id: `FAKE${props.messaging.client.client_id}${Math.floor(Math.random() * 9999)}`,
          chatId,
          imageUrl: null,
          collectionId: null,
          collectionName: null,
          message: messageTxt.replace('[Review Link]', ':review:'),
          productId: null,
          productImage: null,
          productName: null,
          productPrice: null,
          sent: +moment(new Date()).subtract(timeOffset, 'minutes').format('YYYYMMDDHHmmss'),
          sentTimestamp: moment(new Date()),
          storeId: getValidatedStoreIdFromProps(props),
          storeName: null,
          thumbnailUrl: null,
          userId: props.auth.userId,
          userName: `${props.auth.firstName || ''} ${props.auth.lastName || ''}`,
          userImage: `${props.auth.image || ''}`,
          videoUrl: null,
          uuid: respData.uuid,
        };
        tempChatList.unshift(fakeMessageObj);
      }
      if (selectionType === 'products') {
        fakeChatObj = {
          client_id: props.messaging.client.client_id,
          id: `FAKE${props.messaging.client.client_id}${Math.floor(Math.random() * 9999)}`,
          chatId,
          imageUrl: null,
          collectionId: null,
          collectionName: null,
          message: messageTxt.replace('[Review Link]', ':review:'),
          productId: selection.id,
          productImage: selection.image,
          productName: selection.name,
          productPrice: null,
          sent: moment(new Date()).subtract(timeOffset, 'minutes').format('YYYYMMDDHHmmss'),
          sentTimestamp: moment(new Date()),
          storeName: null,
          thumbnailUrl: null,
          userId: props.auth.userId,
          userName: `${props.auth.firstName || ''} ${props.auth.lastName || ''}`,
          userImage: `${props.auth.image || ''}`,
          videoUrl: null,
          uuid: respData.uuid,
          fakeImage: true,
        };
      } else if (selectionType === 'vendorItems') {
        fakeChatObj = {
          client_id: props.messaging.client.client_id,
          id: `FAKE${props.messaging.client.client_id}${Math.floor(Math.random() * 9999)}`,
          chatId,
          imageUrl: null,
          collectionId: null,
          collectionName: null,
          message: messageTxt.replace('[Review Link]', ':review:'),
          productId: selection.id,
          productImage: selection.image,
          productName: selection.name,
          productPrice: null,
          sent: moment(new Date()).subtract(timeOffset, 'minutes').format('YYYYMMDDHHmmss'),
          sentTimestamp: moment(new Date()),
          storeName: null,
          thumbnailUrl: null,
          userId: props.auth.userId,
          userName: `${props.auth.firstName || ''} ${props.auth.lastName || ''}`,
          userImage: `${props.auth.image || ''}`,
          videoUrl: null,
          uuid: respData.uuid,
          fakeImage: true,
        };
      } else {
        fakeChatObj = {
          clientId: props.messaging.client.client_id,
          id: `FAKE${props.messaging.client.client_id}${Math.floor(Math.random() * 9999)}`,
          chatId,
          imageUrl: null,
          collectionId: selection.clientCollectionId || selection.collection_id,
          collectionName: selection.name,
          message: `.app/${props.messaging.client.client_id}/${
            selection.clientCollectionId || selection.collection_id
          }`,
          productId: null,
          productImage: null,
          productName: null,
          productPrice: null,
          sent: +moment(new Date()).subtract(timeOffset, 'minutes').format('YYYYMMDDHHmmss'),
          sentTimestamp: moment(new Date()),
          storeName: null,
          thumbnailUrl: null,
          userId: props.auth.userId,
          userName: `${props.auth.firstName || ''} ${props.auth.lastName || ''}`,
          userImage: `${props.auth.image || ''}`,
          videoUrl: null,
          uuid: respData.uuid,
          fakeImage: true,
        };
      }

      fakeChatObj.storeId = getValidatedStoreIdFromProps(props);
      tempChatList.unshift(fakeChatObj);
    });
    setMsgChatMessages([...tempChatList]);
    setMessageTxt('');
  };

  const { data: lastMessage } = useQuery(
    ['chats', 'lastMessage', props?.messaging?.client?.client_id],
    async () => {
      try {
        const clientId = props?.messaging?.client?.client_id;
        const chats = await clientbookApi.get({ url: `/clients/${clientId}/chats` });
        if (!Array.isArray(chats) || chats.length === 0) return null;
        const sorted = [...chats].sort((a, b) => (b.lastSentTimestamp || 0) - (a.lastSentTimestamp || 0));
        return { storeId: sorted[0].storeId };
      } catch (error) {
        return null;
      }
    },
    {
      enabled: !!props?.messaging?.client?.client_id,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
    },
  );

  const handleDeleteDraft = useCallback(async () => {
    try {
      if (props?.messaging?.userDraft?.id) {
        await deleteUserDraft({
          chatId: props.messaging.client.chat_id,
          draftId: props?.messaging.userDraft.id,
          type: props.messaging.client.type,
        });
        setUserDraft({ id: null, message: '' });
      }
    } catch (error) {
      console.error('Error deleting draft:', error);
    }
  }, [
    props?.messaging?.userDraft?.id,
    props?.messaging?.client?.chat_id,
    props?.messaging?.client?.type,
    setUserDraft,
  ]);

  const sendMessage = async (completeReminder = false, sendAndArchive = null) => {
    console.log('[ChatInputFooter.sendMessage] props.messaging.client:', props.messaging.client);
    console.log('[ChatInputFooter.sendMessage] chat_id:', props?.messaging?.client?.chat_id);
    setIsSendAndArchive(false);
    let archive = sendAndArchive;
    if (archive === null && !props.messaging.chatMessages?.length) {
      archive = false;
    }
    const chatId = props?.messaging?.client?.chat_id;
    const clientId = props?.messaging?.client?.client_id;
    const { type } = props.messaging.client;
    const storeId = getValidatedStoreIdFromProps(props);
    const message = messageTxt || '';
    const isOpen = archive ? 'false' : undefined;

    if (selectedProducts.length > 0) {
      const productIds = selectedProducts.map(product => product.id);
      const respData = await sendStructuredMessage({ type, clientId, chatId, storeId, message, productIds, isOpen });
      if (respData) {
        insertIntoConversationList(selectedProducts, respData, chatId, 'products');
      }
      setSelectedProducts([]);
    } else if (selectedVendorItems.length > 0) {
      const vendorItems = selectedVendorItems.map(product => ({ id: product.id, imageUrl: product.image }));
      const respData = await sendStructuredMessage({ type, clientId, chatId, storeId, message, vendorItems, isOpen });
      if (respData) {
        insertIntoConversationList(selectedVendorItems, respData, chatId, 'vendorItems');
      }
      setSelectedVendorItems([]);
    } else if (selectedCollections.length > 0) {
      const collectionIds = selectedCollections.map(collection => collection.clientCollectionId);
      const respData = await sendStructuredMessage({ type, clientId, chatId, storeId, message, collectionIds, isOpen });
      if (respData) {
        insertIntoConversationList(selectedCollections, respData, chatId, 'collections');
      }
      setSelectedCollections([]);
    } else {
      await sendAPIChatMessage({
        messageTxt,
        fileData,
        chatId: props?.messaging?.client?.chat_id,
        clientId: props?.messaging?.client?.client_id,
        paymentRequestID,
        timeOffset,
        setMessageTxt,
        fileDispatch,
        archive,
        type: props.messaging.client.type,
      });
      if (
        getReviewUrl[process.env.REACT_APP_API_ENV || 'development'] &&
        messageTxt.includes(getReviewUrl[process.env.REACT_APP_API_ENV || 'development'])
      ) {
        const regexReviewBaseUrl = getReviewUrl[process.env.REACT_APP_API_ENV || 'development'].replace(
          /[.*+?^${}()|[\]\\]/g,
          '\\$&',
        );
        const regex = new RegExp(`(${regexReviewBaseUrl}/)([a-zA-Z0-9-]+)`, 'g');
        const match = messageTxt.match(regex);
        if (match && match.length > 0) {
          const matchArray = match[0].split('/');
          if (matchArray && matchArray.length > 3) {
            const code = matchArray[3];
            if (code) {
              await putRequest({
                params: ['stores', props.auth.storeId, 'google', 'reviews', 'shortUrl', code],
                data: {
                  sent: true,
                },
                loadingStatusOff: true,
              });
            }
          }
        }
      }
    }
    if (completeReminder) {
      const reqObj = {
        params: ['today', props.auth.merchantId, 'save'],
        data: { selected: [props?.messaging?.client] },
        query: {
          storeId: props.auth.storeId,
          associateId: props.auth.userId,
          createdBy: `${props.auth.firstName || ''} ${props.auth.lastName || ''}`,
        },
      };
      const data = await postRequest(reqObj);
      if (data) {
        getReminderData(props?.messaging?.client, props.auth.merchantId);
        setShowPopReminder(false);
        setShowPopSuccessReminder(true);
        setMsgReminderId(null);
      }
    }
    handleDeleteDraft();
    setMsgReminderId(null);
    setShowPopReminder(false);
    scrollToBottomOfChat();
    setShowSearchResults(false);
    setMsgSearchText('');
    setPaymentRequestID('');
  };

  const showOverlay = useMemo(
    () =>
      props.allStoreConversationHistory &&
      lastMessage?.storeId !== 0 &&
      lastMessage?.storeId &&
      lastMessage?.storeId !== props.auth.selectedStore &&
      props.auth.stores.includes(store => store.id === lastMessage?.storeId),
    [lastMessage, props.auth.selectedStore, props.auth.stores, props.allStoreConversationHistory],
  );

  const sendAndArchive = async () => {
    setIsSendAndArchive(true);
    if (showOverlay) {
      setShowStoreModal(true);
      return;
    }
    if (props.messaging.client.reminderId) {
      setShowPopReminder(true);
      return;
    }
    await sendMessage(false, true);
    setMsgClient({ isOpen: false });
    setMsgResetClient({});

    if (typeof props.setDrawerToggle === 'function') {
      props.setDrawerToggle(true);
    }
  };

  const getAutoReminderIdTemplate = useMemo(() => {
    if (props?.today?.todayClientChat?.temporaryConfigId && props?.today?.todayClientChat?.temporaryConfigId !== 0) {
      return props.today.todayClientChat.temporaryConfigId;
    }
    const {
      life_event_action_config_id,
      custom_event_action_config_id,
      sales_opp_action_config_id,
      tag_action_config_id,
    } = props?.messaging?.client || {};
    // Use config IDs for template filtering (these match template.autoReminderId)
    return (
      tag_action_config_id ||
      life_event_action_config_id ||
      custom_event_action_config_id ||
      sales_opp_action_config_id ||
      null
    );
  }, [props]);
  const templates = useMessageTemplates({
    togglePopup: () => showTemplatePopup(p => !p),
    merchantId: props.auth.merchantId,
    licenseKey: props.auth.licenseKey,
    fileDispatch,
    setMessageText: setMessageTxt,
    clientName: props.messaging.client.preferred_name || props.messaging.client.name,
    stores: props.auth.stores,
    storeId: props.auth.selectedStore,
    associateName: props.auth.firstName,
    clientId: props?.messaging?.client?.client_id,
    allTemplates: true,
    client: props?.messaging?.client,
    autoReminderId: getAutoReminderIdTemplate,
  });

  useEffect(() => {
    if (!props?.client?.client_id) {
      return;
    }
    if (props?.client?.relationships?.length > 0) {
      const cli_id = props?.client?.client_id;
      const formatData = props?.client?.relationships
        .filter(rel => !!rel.relationship)
        .map(item => {
          if (item.client_id === parseInt(cli_id, 10)) {
            return {
              name: getFirstName(item.related_client_name),
              id: item.related_client_id,
              relationship: item.relationship,
              relationship_id: item.id,
            };
          }
          if (item.related_client_id === parseInt(cli_id, 10)) {
            return {
              name: getFirstName(item.client_name),
              id: item.client_id,
              relationship: `${item.relationship}${
                nonInverseRelationshipTypes.includes(item.relationship?.toLowerCase()) ? '' : ' of'
              }`,
              relationship_id: item.id,
            };
          }
          return null;
        })
        .filter(Boolean);
      setRelationships(formatData);
    } else {
      setRelationships([]);
    }
  }, [props.client?.client_id]);

  const handleSendButton = useCallback(() => {
    if (props.messaging.client.reminderId) {
      setShowPopReminder(true);
    } else if (showOverlay) {
      setShowStoreModal(true);
    } else {
      sendMessage(false);
    }
  }, [sendMessage, props.messaging, showOverlay]);

  const inboxNoWhatsApp = () => {
    const { client_id, preferred_contact_type, WA_receive, type } = props.messaging.client;
    if ((client_id && whatsappTimeCheck(preferred_contact_type, WA_receive)) || type !== 'C') {
      return (
        <MessageInputActions
          sendMessage={handleSendButton}
          sendAndArchive={sendAndArchive}
          changeHandler={setMessageTxt}
          val={messageTxt}
          reviewLink={props.messaging.reviewLink}
          associate={props.auth.firstName}
          client={props.messaging.client}
          key={client_id}
          showTemplatePopup={showTemplatePopup}
          showPaymentsPopup={showPaymentsPopup}
          templates={templates}
          payments={Number(props.auth.payments) > 0}
          relationships={relationships}
          type={props.type}
          handleAddProduct={handleAddProduct}
          handleDeleteProduct={handleDeleteProduct}
          handleAddVendorItem={handleAddVendorItem}
          handleDeleteVendorItem={handleDeleteVendorItem}
          selectedVendorItems={selectedVendorItems}
          selectedProducts={selectedProducts}
          selectedCollections={selectedCollections}
          handleAddCollection={handleAddCollection}
          handleDeleteCollection={handleDeleteCollection}
          location="inbox"
          handleDeleteDraft={handleDeleteDraft}
        />
      );
    }
    if (client_id && !whatsappTimeCheck(preferred_contact_type, WA_receive)) {
      return (
        <WhatsappMessageInput
          sendMessage={sendMessage}
          changeHandler={setMessageTxt}
          associateName={props.auth.firstName || props.auth.lastName}
          clientName={props?.messaging?.client?.name}
          reviewLink
          merchantId={props?.auth?.merchantId}
          clientId={client_id}
        />
      );
    }
  };

  const getClientFirst = () => {
    return getFirstName(props?.messaging?.client?.name);
  };

  const handleChangeStore = useCallback(
    async storeId => {
      setMsgClient({
        sendStoreId: storeId,
      });
      await sendMessage(false, isSendAndArchive);
      setMsgClient({
        sendStoreId: null,
      });
      setShowStoreModal(false);
      if (isSendAndArchive) {
        setMsgClient({ isOpen: false });
        setMsgResetClient({});

        if (typeof props.setDrawerToggle === 'function') {
          props.setDrawerToggle(true);
        }
      }
    },
    [props.messaging.client, sendMessage, isSendAndArchive],
  );

  return (
    <div className="w-100-P" id="footer-icons">
      {inboxNoWhatsApp()}
      {showOverlay && (
        <StoreModal
          open={showStoreModal}
          onClose={() => setShowStoreModal(false)}
          stores={props.auth.stores.filter(store =>
            [props.auth.selectedStore, lastMessage?.storeId].includes(store.id),
          )}
          handleStore={handleChangeStore}
          clientName={props.messaging.client.preferred_name || props.messaging.client.name}
          lastMessageStoreId={lastMessage?.storeId}
          selectedStore={props.auth.selectedStore}
        />
      )}
      <ChatModal
        type={props.type}
        drawer={{
          bodyStyle: { padding: 0 },
          push: false,
          width: 500,
        }}
        open={paymentsPopup}
        onClose={() => showPaymentsPopup(false)}
      >
        <PopMessagePayment
          className={props.type === 'full' ? 'chat-payment-modal-container-full' : 'chat-payment-modal-container-right'}
          onCancel={() => {
            showPaymentsPopup(false);
          }}
          clientName={getClientFirst()}
          clientFullName={props.messaging.client.name}
          popStyle={{ overflowY: 'scroll' }}
          showPaymentsPopup={showPaymentsPopup}
          clientId={props.messaging.client.client_id}
          setMessageTxt={setMessageTxt}
          setPaymentRequestID={setPaymentRequestID}
        />
      </ChatModal>
      <ChatModal
        type={props.type}
        drawer={{
          bodyStyle: { padding: 0 },
          push: false,
          width: 600,
        }}
        open={templatePopup}
        onClose={() => showTemplatePopup(false)}
      >
        <ChatTemplatePopup
          type={props.type}
          setShowPopup={showTemplatePopup}
          showPopup={templatePopup}
          setShowPopConfirm={() => {}}
          templates={templates}
          tableData={templates.tableData}
          setMsgText={setMessageTxt}
          fileDispatch={fileDispatch}
          currentClientName={props.messaging.client?.preferred_name || getFirstName(props.messaging?.client?.name)}
          associateName={`${props.auth.firstName || ''}`}
          reviewLink={props.messaging.reviewLink}
          auth={props.auth}
          client={props.messaging.client}
          activeReminderId={getAutoReminderIdTemplate}
        />
      </ChatModal>
      {showPopReminder ? (
        <PopMessage
          popStyle={{
            width: '375px',
          }}
          confirmationButtonText="YES"
          cancelButtonText="NO"
          confirm={
            props.messaging.client.description ? (
              <>
                {`Message sent from reminder "${props.messaging.client.description}".`}
                <br />
                Would you like to complete this reminder?
              </>
            ) : (
              'Would you like to complete this reminder?'
            )
          }
          description=""
          noButtonDisable
          confirmStyle={{ textAlign: 'center' }}
          onCancel={() => sendMessage(false, isSendAndArchive)}
          onConfirm={() => sendMessage(true, isSendAndArchive)}
        />
      ) : null}
      {showPopSuccessReminder ? (
        <PopMessage
          popStyle={{
            width: '375px',
          }}
          confirmationButtonText="Ok"
          confirmStyle={{ textAlign: 'center' }}
          confirm={
            props.messaging.client.description
              ? `Reminder "${props.messaging.client.description}" completed!`
              : 'Reminder completed!'
          }
          noButtonDisable
          onConfirm={() => setShowPopSuccessReminder(false)}
          hasCancelButton={false}
        />
      ) : null}
    </div>
  );
};
const mapStateToProps = state => ({
  messaging: state.messaging,
  auth: state.auth,
  today: state.today,
  client: state.client,
});
export default connect(mapStateToProps, {})(ChatInputFooter);
